(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracService', NasracService);

    NasracService.$inject = ['$resource'];

    function NasracService ($resource) {
        var resourceUrl =  'api/nasrac-services/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getMissingBRSIds' : {
                method : 'GET',
                url : 'api/nasrac-services/getMissingBRSIds',
                cache: false,
                isArray: true

            },
			'download' : {
				method : 'GET',
				url : 'api/nasrac-services/download',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			}
        });
    }
})();
